import React from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../../components/BaseComponent';
import BackButton from '../../../../components/UI/BackButton';
import SelectItem from '../../../../components/UI/SelectItem';
import PickingService from '../../../../services/PickingService';
import { ENUMS } from '../../../../utils/constants';
import { enumText, hideKeyboardDevice, isNullOrEmpty, showMessageToastCustom } from '../../../../utils/util';

class ListItemOrderDetail extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                userName: ''
            },
            modelMessage: {
                title: '',
                message: '',
                confirm: '',
                order: ''
            },
            validations: [
                {
                    group: 'transfer',
                    field: 'model.userName',
                    rules: [
                        {
                            required: true,
                            message: this.translate('validations:required'),
                        },
                        {
                            minLength: 3,
                            message: this.translate('validations:min-length-field'),
                        }
                    ],
                    isValid: false,
                    message: '',
                }
            ],
        };

        this.msgHandler = this.msgHandler.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener('message', this.msgHandler);
        M.updateTextFields();
        hideKeyboardDevice();
    }

    componentWillUnmount = () => {
        document.removeEventListener('message', this.msgHandler);
    }

    isValidForm = () => {
        const result = this.isValid();
        return result;
    }

    submit = () => {
        if (this.state.model.userName === undefined || this.state.model.userName === '') {
            showMessageToastCustom(this.translate('general:warning'),
                this.translate('validations:invalid-user'),
                3000, 'mdi mdi-alert-circle-outline red-text');

            return;
        }

        this.props.changeUserOrder(this.props.order.orderId, this.state.model.userName, () => {
            this.setState({
                model: {
                    userName: 'fiatauto\\'
                }
            }, () => { this.props.history.goBack(); });
        });
    }

    cancel = () => {
        this.props.history.goBack();
    }

    showMessageModal = (title, message, order, confirm) => {
        const auxModel = this.state.modelMessage;
        auxModel.title = title;
        auxModel.message = message;
        auxModel.order = order;
        auxModel.confirm = confirm;
        this.setState({ modelMessage: auxModel }, () => {
            this.messageModal.show();
        });
    }

    getStatus = (value) => this.translate(enumText(ENUMS.eOrderStatus, value), 'expedition');

    msgHandler = (e) => {
        const content = window.ReactNativeWebView;
        content.postMessage('');

        const value = e.data;
        if (value.length >= 3) {
            this.setState({ model: { userName: value } }, () => { M.updateTextFields(); });
        }
    }

    scanner = () => {
        if (navigator.userAgent === 'logisticspwa') {
            const content = window.ReactNativeWebView;
            content.postMessage('exibirTela');
        } else {
            this.showMessageToastCustom(this.translate('general:warning'), this.translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            this.setState({ model: { userName: value } }, () => { M.updateTextFields(); });
        }
    };

    onChangeSelectItem = (value) => {
        this.setState({ model: { userName: value } }, () => { M.updateTextFields(); });
    };


    render() {
        return (
            <div>
                <BackButton {...this.props} />
                <div className="container-fluid h-65">
                    <div className="row">
                        <div className="title">
                            <i className="mdi mdi-dolly" />
                            {this.translate('expedition:picking.title')}
                        </div>
                        <div className="subtitle">
                            | <i className="material-icons">business_center</i>
                            {this.translate('expedition:picking.order')}
                        </div>
                        <div className="subtitle">
                            | <i className="material-icons">contacts</i>
                            {this.translate('expedition:picking.userTransfer')}
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginTop: '40px', }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px' }}>
                            <form onKeyDown={this.handleFormKeyDown}>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1p5r">{this.props.order.orderCode}</span>
                                        <label className="active" htmlFor="productId">{this.translate('expedition:picking.orderCode')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{this.props.order.supplierName}</span>
                                        <label className="active" htmlFor="pn">{this.translate('expedition:picking.supplier')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{this.getStatus(this.props.order.status)}</span>
                                        <label className="active" htmlFor="status">{this.translate('general:status')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <i className="mdi mdi-qrcode posfix" onClick={() => this.scanner(this)} />
                                        <SelectItem
                                            required
                                            id="username"
                                            name="model.userName"
                                            label={this.translate('expedition:picking.new-userName')}
                                            onChange={(event) => this.onChangeSelectItem(event)}
                                            onChangeData={this.onChangeData}
                                            data={this.props.usersFromElog ? this.props.usersFromElog.map(item => {
                                                return {
                                                    id: item.id,
                                                    text: item.user
                                                }
                                            }) : []}
                                        />
                                    </div>
                                </div>
                                <div className="card-action row center" style={{ padding: '1rem 0', marginBottom: '0' }}>
                                    <button
                                        type="button"
                                        onClick={this.cancel.bind(this)}
                                        className="col s6
                                    btn
                                    waves-effect
                                    waves-light
                                    btn-flat"
                                    >
                                        {this.translate('general:cancel')}
                                    </button>
                                    <button
                                        type="button"
                                        className="col s6
                                    btn
                                    btn-principal
                                    waves-effect
                                    waves-light"
                                        onClick={this.submit.bind(this)}
                                    >
                                        {this.translate('general:confirm')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        order: state.pickingReducer.order,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeUserOrder: (orderId, newUser, callback) => {
            dispatch(PickingService.changeUserOrder(orderId, newUser, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListItemOrderDetail)));
